export default __webpack_public_path__ + "static/UnavailableMessageClock-45b99563f7c90ef041003366d0317bac.jpg";